const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 sm:col-span-2">
            <h3 className="text-xl sm:text-2xl font-bold text-emerald-400 mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              CMAP運動健康品格寒假營隊
            </h3>
            <p className="text-sm sm:text-base text-gray-300 mb-3 sm:mb-4 leading-relaxed">
              專為青少年設計的寒假營隊，透過專業教練指導和安全的活動環境，讓每個孩子都能在多元課程中學習成長，建立自信心和友誼。
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=100089989064527&locale=zh_TW" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-facebook-fill text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-instagram-line text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-youtube-line text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">快速連結</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-sm sm:text-base text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  關於我們
                </a>
              </li>
              <li>
                <a href="#programs" className="text-sm sm:text-base text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  營隊活動
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-sm sm:text-base text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  活動花絮
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm sm:text-base text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  聯絡我們
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">聯絡資訊</h4>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-start space-x-2 sm:space-x-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-emerald-400"></i>
                </div>
                <span className="text-xs sm:text-sm text-gray-300">台中市北屯區北屯路388號2樓</span>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-emerald-400"></i>
                </div>
                <span className="text-xs sm:text-sm text-gray-300">(04) 2243-6255</span>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-emerald-400"></i>
                </div>
                <span className="text-xs sm:text-sm text-gray-300 break-all">richqazstrong@yahoo.com.tw</span>
              </div>
            </div>
          </div>
        </div>

        {/* Related Organizations */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6 text-center">相關企業</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="text-center">
              <a href="https://www.yeswecanedu.com" target="_blank" rel="noopener noreferrer" className="block bg-gray-800 hover:bg-gray-700 transition-colors rounded-lg p-4 sm:p-6 cursor-pointer">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3 bg-emerald-400 rounded-full">
                  <i className="ri-book-open-line text-lg sm:text-xl text-white"></i>
                </div>
                <h5 className="text-sm sm:text-base text-white font-semibold mb-1 sm:mb-2">威斯理美語補習班</h5>
                <p className="text-xs sm:text-sm text-gray-400">專業英語教學，培養孩子國際視野</p>
              </a>
            </div>
            <div className="text-center">
              <a href="https://www.cmleducate.com" target="_blank" rel="noopener noreferrer" className="block bg-gray-800 hover:bg-gray-700 transition-colors rounded-lg p-4 sm:p-6 cursor-pointer">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3 bg-emerald-400 rounded-full">
                  <i className="ri-compass-3-line text-lg sm:text-xl text-white"></i>
                </div>
                <h5 className="text-sm sm:text-base text-white font-semibold mb-1 sm:mb-2">CM探索教育科技股份有限公司</h5>
                <p className="text-xs sm:text-sm text-gray-400">創新教育科技，啟發學習潛能</p>
              </a>
            </div>
            <div className="text-center sm:col-span-2 md:col-span-1">
              <a href="https://www.taiwanchild.com" target="_blank" rel="noopener noreferrer" className="block bg-gray-800 hover:bg-gray-700 transition-colors rounded-lg p-4 sm:p-6 cursor-pointer">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3 bg-emerald-400 rounded-full">
                  <i className="ri-heart-line text-lg sm:text-xl text-white"></i>
                </div>
                <h5 className="text-sm sm:text-base text-white font-semibold mb-1 sm:mb-2">中華原住民暨弱勢家庭孩童關懷協會</h5>
                <p className="text-xs sm:text-sm text-gray-400">關懷弱勢兒童，傳遞愛與希望</p>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-gray-400">
            © 2024 CMAP運動健康品格寒假營隊. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="text-emerald-400 hover:text-emerald-300 ml-1 cursor-pointer">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;